/**
 * i18n Configuration for AI Commerce OS
 * Supports: English, Hindi, Tamil, Telugu, Kannada, Bengali, Marathi, Gujarati, Malayalam, Punjabi
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import available translation files
import translationEN from './locales/en/translation.json';
import translationHI from './locales/hi/translation.json';
import translationTA from './locales/ta/translation.json';

// Translation resources (only include completed translations)
const resources = {
  en: { translation: translationEN },
  hi: { translation: translationHI },
  ta: { translation: translationTA }
  // Telugu, Kannada, Bengali, Marathi, Gujarati, Malayalam, Punjabi - Coming soon
  // Will be added as translations are completed
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language
    debug: false, // Set to true for debugging
    
    // Supported languages (only enabled ones)
    supportedLngs: ['en', 'hi', 'ta'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Cache user language
      caches: ['localStorage'],
      
      // localStorage key
      lookupLocalStorage: 'i18nextLng',
    }
  });

export default i18n;
